import languageBtn from './languageBtn'
import orderStatuses from './orderStatuses'
import common from './common'
import header from './header'
import callFeedback from './callFeedback'
import footerBtn from './footerBtn'
import mainPage from './mainPage'
import reschedule from './reschedule'
import signature from './signature'
import errorPage from './errorPage'
import access from './access'

export default {
  'language-btn': languageBtn,
  'order-status': orderStatuses, // sửa lỗi chính tả 'order-statuse' thành 'order-status'
  common,
  header,
  'call-feedback': callFeedback,
  'ready-for-delivery': 'Đơn hàng của bạn đã được lưu trữ an toàn tại cơ sở và sẽ được giao ',
  'footer-btn': footerBtn,
  'main-page': mainPage,
  reschedule,
  signature,
  'error-page': errorPage,
  access,
}
